import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-indices-grid',
    templateUrl: './indices-grid.component.html',
    styleUrls: ['./indices-grid.component.scss'],
    standalone: false
})
export class IndicesGridComponent {
	@Input() indices: any[];
	Object = Object;
}
